import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export interface RenameVDRFolderRequest {
    engagementId: number;
    folderPath: string;
    newName: string;
}

export const RenameVDRFolder = createAsyncThunk(
    'dataRoom/renameFolder',
    async (
        { engagementId, folderPath, newName }: RenameVDRFolderRequest,
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.put(
                `api/VirtualDataRoomDocument/${engagementId}/folder/rename`,
                { folderPath, newName }
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not rename folder at the moment.',
                    'error'
                );
                throw new Error('Failed to rename folder');
            }

            return response.data;
        } catch (error) {
            createNotification(
                'An error occurred while renaming folder.',
                'error'
            );
            throw error;
        }
    }
);
